export default [
  {
    path: "/activity-2024/cp_recharge_value/:activityKey",
    component: () =>
      import(
        /* webpackChunkName: 'cp_recharge' */ `@/components/activity/recharge_module/super-value-gift/index.vue`
      ),
    props: (route) => ({
      activityKey: route.params.activityKey,
    }),
  },
  {
    path: "/activity-2024/cp_recharge/:activityKey",
    component: () =>
      import(
        /* webpackChunkName: 'cp_recharge_value' */ `@/components/activity/recharge_module/recharge-gift-energy/index.vue`
      ),
    props: (route) => ({
      activityKey: route.params.activityKey,
    }),
  },
  {
    path: "/activity-2024/cp_recharge_continue/:activityKey",
    component: () =>
      import(
        /* webpackChunkName: 'cp_recharge_value' */ `@/components/activity/recharge_module/continuous-recharge-page/index.vue`
      ),
    props: (route) => ({
      activityKey: route.params.activityKey,
    }),
  },
  {
    path: "/activity-2024/surprise_box_page/:activityKey",
    component: () =>
      import(
        /* webpackChunkName: 'surprise_box_page' */ `@/components/activity/recharge_module/surprise-box-page/index.vue`
      ),
    props: (route) => ({
      activityKey: route.params.activityKey,
    }),
  },
  {
    path: "/activity-2023/mingrentang/:entryType",
    component: () =>
      import(
        /* webpackChunkName: 'mingrentang-idnex' */ `@/views/2024/mingrentang/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
    }),
  },
  {
    path: "/activity-2023/mingrentang-set",
    component: () =>
      import(
        /* webpackChunkName: 'mingrentang-set' */ `@/views/2024/mingrentang/set.vue`
      ),
  },
  {
    path: "/activity-2023/piece-shop/:entryType",
    component: () =>
      import(
        /* webpackChunkName: 'piece-shop-idnex' */ `@/views/2024/piece-shop/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
    }),
  },
  {
    path: "/activity-2024/rookie-book/:entryType",
    component: () =>
      import(
        /* webpackChunkName: 'rookie-book' */ `@/views/2024/rookie-book/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
    }),
  },
  // {
  //   path: "/activity-2024/summer-star",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star' */ `@/views/2024/summer_star/index.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/summer-star/rank",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star-rank' */ `@/views/2024/summer_star/rank.vue`
  //     ),
  //   props: (route) => ({
  //     index: Number(route.query.index) || 0,
  //   }),
  // },
  // {
  //   path: "/activity-2024/summer-star/exchange-record",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star-exchange-record' */ `@/views/2024/summer_star/exchange-record.vue`
  //     ),
  //   props: (route) => ({
  //     index: Number(route.query.index) || 0,
  //   }),
  // },
  // {
  //   path: "/activity-2024/summer-star/reward",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star-reward' */ `@/views/2024/summer_star/reward.vue`
  //     ),
  //   props: (route) => ({
  //     index: Number(route.query.index) || 0,
  //   }),
  // },
  // {
  //   path: "/activity-2024/summer-star/share",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star-share' */ `@/views/2024/summer_star/share.vue`
  //     ),
  //   props: (route) => ({
  //     id: route.query.uid,
  //   }),
  // },  {
  //   path: "/activity-2024/summer-star/help-rank",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star-help-rank' */ `@/views/2024/summer_star/help-rank.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/summer-star/ticket-record",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star-ticket-record' */ `@/views/2024/summer_star/ticket-record.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/summer-star/chest",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star-chest' */ `@/views/2024/summer_star/components/dress-no-extra-chest/index.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/summer-star/ticket-log",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'summer-star-ticket-log' */ `@/views/2024/summer_star/ticket-log.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/summer-star/live-exchange-log",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'live-exchange-log' */ `@/views/2024/summer_star/live-exchange-log.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/summer-star/gem-log",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'gem-log' */ `@/views/2024/summer_star/gem-record.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/dream_0118/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'dream_0118_index' */ `@/views/2024/heart-plan/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/food_0125/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'food_0125_index' */ `@/views/2024/food_0125/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/dragon_0206/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'dragon_0206_index' */ `@/views/2024/dragon_0206/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/perfect-couple/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'perfect-couple' */ `@/views/2024/perfect-couple/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: route.params.firstTab,
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/perfect-couple-recharge",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'perfect-couple-recharge' */ `@/views/2024/perfect-couple/recharge-gift/index.vue`
  //     ),
  // },

  // {
  //   path: "/activity-2024/lantern_0222/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'lantern-festival' */ `@/views/2024/lantern-festival/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/girl_0229/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'girl_0229' */ `@/views/2024/girl_0229/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/purelove_0312/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'purelove_0312' */ `@/views/2024/purelove_0312/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/purelove_0312_recharge",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'purelove_0312_recharge' */ `@/views/2024/purelove_0312/recharge-gift/index.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/purelove_0312_love/:relation_id/:rose",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'purelove_0312'_love */ `@/views/2024/purelove_0312/love_index.vue`
  //     ),
  //   props: (route) => ({
  //     relation_id: Number(route.params.relation_id),
  //     rose: Number(route.params.rose),
  //   }),
  // },
  // {
  //   path: "/activity-2024/saye_0314/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'saye_0314' */ `@/views/2024/saye_0314/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/wind_0321/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'wind_0321' */ `@/views/2024/wind_0321/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/fool_0328/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'fool_0328' */ `@/views/2024/fool_0328/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/relationship_0402/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'relationship_0402' */ `@/views/2024/relationship_0402/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/relationship_0402_recharge",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'relationship_0402_recharge' */ `@/views/2024/relationship_0402/recharge-gift/index.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/relationship_0402_love/:relation_id/:rose",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'relationship_0402_love' */ `@/views/2024/relationship_0402/love_index.vue`
  //     ),
  //   props: (route) => ({
  //     relation_id: Number(route.params.relation_id),
  //     rose: Number(route.params.rose),
  //   }),
  // },
  // {
  //   path: "/activity-2024/rich_0411/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'rich_0411_first_index' */ `@/views/2024/rich_0411/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/rich_0411/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'rich_0411_module_index' */ `@/views/2024/rich_0411/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/cp_0418/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'cp_0418' */ `@/views/2024/cp_0418/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },

  // {
  //   path: "/activity-2024/holiday_0425/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'holiday_0425_first_index' */ `@/views/2024/holiday_0425/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/holiday_0425/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'holiday_0425_module_index' */ `@/views/2024/holiday_0425/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/master_0430/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'master_0430' */ `@/views/2024/master_0430/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/master_0430_recharge",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: 'master_0430_recharge' */ `@/views/2024/master_0430/recharge-gift/index.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/0509_summer/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0509_summer_first_index' */ `@/views/2024/0509_summer/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/0509_summer/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0509_summer_module_index' */ `@/views/2024/0509_summer/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0516_cp/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0516_cp' */ `@/views/2024/0516_cp/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/0516_cp_love_desc_index",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0516_cp' */ `@/views/2024/0516_cp/components/first-tab/components/share-sugar/love-desc-index.vue`
  //     ),
  // },
  // {
  //   path: "/activity-2024/0523_story/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0523_story_first_index' */ `@/views/2024/0523_story/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/0523_story/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0523_story_module_index' */ `@/views/2024/0523_story/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0530_relation/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0530_relation' */ `@/views/2024/0530_relation/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/0606_dragonboat/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0606_dragonboat_first_index' */ `@/views/2024/0606_dragonboat/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/0606_dragonboat/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0606_dragonboat_module_index' */ `@/views/2024/0606_dragonboat/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0613_cp_love/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0613_cp_love' */ `@/views/2024/0613_cp_love/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/0620_xiazhi/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0620_xiazhi_first_index' */ `@/views/2024/0620_xiazhi/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0620_xiazhi/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0620_xiazhi_module_index' */ `@/views/2024/0620_xiazhi/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0627_relation/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0627_relation' */ `@/views/2024/0627_relation/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },

  // {
  //   path: "/activity-2024/0704_yuzhou/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0704_yuzhou_first_index' */ `@/views/2024/0704_yuzhou/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0704_yuzhou/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0704_yuzhou_module_index' */ `@/views/2024/0704_yuzhou/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0711_cp_love/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0711_cp_love' */ `@/views/2024/0711_cp_love/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },

  // {
  //   path: "/activity-2024/0704_yuzhou/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0704_yuzhou_first_index' */ `@/views/2024/0704_yuzhou/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0704_yuzhou/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0704_yuzhou_module_index' */ `@/views/2024/0704_yuzhou/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0711_cp_love/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0711_cp_love' */ `@/views/2024/0711_cp_love/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/0718_flower/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0718_flower_first_index' */ `@/views/2024/0718_flower/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0718_flower/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0718_flower_module_index' */ `@/views/2024/0718_flower/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0725_relation/:firstTab/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0725_relation' */ `@/views/2024/0725_relation/index.vue`
  //     ),
  //   props: (route) => ({
  //     firstTab: Number(route.params.firstTab),
  //     entryType: route.params.entryType,
  //   }),
  // },
  // {
  //   path: "/activity-2024/0801_kuang/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0801_kuang_first_index' */ `@/views/2024/0801_kuang/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0801_kuang/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0801_kuang_module_index' */ `@/views/2024/0801_kuang/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0808_cp_love/:entryType",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0808_cp_love_first_index' */ `@/views/2024/0808_cp_love/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0808_cp_love/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0801_kuang_module_index' */ `@/views/2024/0808_cp_love/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0815_guang/:entryType/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0815_guang_first_index' */ `@/views/2024/0815_guang/first_index.vue`
  //     ),
  //   props: (route) => ({
  //     entryType: route.params.entryType,
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0815_guang/:entryType/module/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0815_guang_module_index' */ `@/views/2024/0815_guang/components/module_index.vue`
  //     ),
  //   props: (route) => ({
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  // {
  //   path: "/activity-2024/0822_relation/:entryType/:tab/:firstTab",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: '0822_relation' */ `@/views/2024/0822_relation/index.vue`
  //     ),
  //   props: (route) => ({
  //     entryType: route.params.entryType,
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //   }),
  // },
  {
    path: "/activity-2024/0829_fourth/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0829_fourth_first_index' */ `@/views/2024/0829_fourth/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/0829_fourth/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0829_fourth_module_index' */ `@/views/2024/0829_fourth/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/0905_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0905_cp_love' */ `@/views/2024/0905_cp_love/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/article-journey",
    component: () =>
      import(
        /* webpackChunkName: 'article-journey' */ `@/views/2024/article-journey/index.vue`
      ),
    props: (route) => {
      console.log(!!route.query.isSquare);
      return {
        isSquare: !!route.query.isSquare,
      };
    },
  },
  {
    path: "/activity-2024/0912_qiu/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0912_qiu_first_index' */ `@/views/2024/0912_qiu/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/0912_qiu/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0912_qiu_module_index' */ `@/views/2024/0912_qiu/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/0919_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0919_relation' */ `@/views/2024/0919_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/0926_hai/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0926_hai_first_index' */ `@/views/2024/0926_hai/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/0926_hai/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0926_hai_module_index' */ `@/views/2024/0926_hai/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/0930_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '0930_cp_love' */ `@/views/2024/0930_cp_love/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1010_yi/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1010_yi_first_index' */ `@/views/2024/1010_yi/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1010_yi/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1010_yi_module_index' */ `@/views/2024/1010_yi/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1017_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1017_relation' */ `@/views/2024/1017_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/pia_2024/:firstTab/:type/:id",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024-index' */ `@/views/2024/pia_2024/index.vue`
      ),
    props: (route) => ({
      firstTab: Number(route.params.firstTab),
      entryType: route.params.type,
      id: Number(route.params.id),
    }),
  },
  {
    path: "/activity-2024/pia_2024_invite",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_invite' */ `@/views/2024/pia_2024/invite.vue`
      ),
  },
  {
    path: "/activity-2024/pia_2024_diamond_chest",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_diamond_chest' */ `@/views/2024/pia_2024/diamond-chest.vue`
      ),
  },
  {
    path: "/activity-2024/pia_2024_diamond_chest_reward",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_diamond_chest_reward' */ `@/views/2024/pia_2024/diamond-chest-reward.vue`
      ),
  },
  {
    path: "/activity-2024/pia_2024_product",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_product' */ `@/views/2024/pia_2024/product-list.vue`
      ),
  },

  {
    path: "/activity-2024/pia_2024_rank/:id",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_rank' */ `@/views/2024/pia_2024/rank.vue`
      ),
    props: (route) => ({
      id: Number(route.params.id),
    }),
  },
  {
    path: "/activity-2024/pia_2024_record/:type/:id",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_record' */ `@/views/2024/pia_2024/vote-record.vue`
      ),
    props: (route) => ({
      type: Number(route.params.type),
      id: Number(route.params.id),
    }),
  },
  {
    path: "/activity-2024/pia_2024_uplist",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_uplist' */ `@/views/2024/pia_2024/up-list.vue`
      ),
  },
  {
    path: "/activity-2024/pia_2024_chest",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_chest' */ `@/views/2024/pia_2024/components/part2/dress-no-extra-chest/index.vue`
      ),
    props: (route) => ({
      activityKey: route.query.key,
    }),
  },
  {
    path: "/activity-2024/pia_2024_replay",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_replay' */ `@/views/2024/pia_2024/replay.vue`
      ),
  },
  {
    path: "/activity-2024/pia_2024_team",
    component: () =>
      import(
        /* webpackChunkName: 'pia_2024_team' */ `@/views/2024/pia_2024/team.vue`
      ),
  },
  {
    path: "/activity-2024/1024_shuang/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1024_shuang_first_index' */ `@/views/2024/1024_shuang/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1024_shuang/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1024_shuang_module_index' */ `@/views/2024/1024_shuang/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1031_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1031_cp_love' */ `@/views/2024/1031_cp_love/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1031_cp_love",
  },
  {
    path: "/activity-2024/1107_qiang/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1107_qiang_first_index' */ `@/views/2024/1107_qiang/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1107_qiang/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1107_qiang_module_index' */ `@/views/2024/1107_qiang/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1107_qiang",
  },
  {
    path: "/activity-2024/1114_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1114_relation' */ `@/views/2024/1114_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1114_relation",
  },
  {
    path: "/activity-2024/1121_sen/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1121_sen_first_index' */ `@/views/2024/1121_sen/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1121_sen/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1121_sen_module_index' */ `@/views/2024/1121_sen/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1121_sen",
  },
  {
    path: "/activity-2024/1128_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1128_cp_love' */ `@/views/2024/1128_cp_love/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1128_cp_love",
  },
  {
    path: "/activity-2024/hex",
    component: () =>
      import(
        /* webpackChunkName: 'hex' */ `@/components/activity/play_module/hex/index.vue`
      ),
    name: "hex",
  },
  {
    path: "/activity-2024/1205_han/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1205_han_first_index' */ `@/views/2024/1205_han/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1205_han/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1205_han_module_index' */ `@/views/2024/1205_han/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1205_han",
  },
  {
    path: "/activity-2024/1212_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1212_cp_love_first_index' */ `@/views/2024/1212_cp_love/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1212_cp_love/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1212_cp_love_module_index' */ `@/views/2024/1212_cp_love/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1212_cp_love",
  },
  {
    path: "/activity-2024/1219_sui/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1219_sui_first_index' */ `@/views/2024/1219_sui/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/1219_sui/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1219_sui_module_index' */ `@/views/2024/1219_sui/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1219_sui",
  },
  {
    path: "/activity-2024/1226_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '1226_relation' */ `@/views/2024/1226_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "1226_relation",
  },
  {
    path: "/activity-2024/250102_shi/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250102_shi_first_index' */ `@/views/2024/250102_shi/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250102_shi/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250102_shi_module_index' */ `@/views/2024/250102_shi/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250102_shi",
  },
  {
    path: "/activity-2024/250109_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250109_relation' */ `@/views/2024/250109_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250109_relation",
  },
  // {
  //   path: "/activity-2024/:entryType/:tab/:firstTab",
  //   component: () => import("@/views/common/jump-index/index.vue"),
  //   props: (route) => ({
  //     entryType: route.params.entryType,
  //     tab: Number(route.params.tab),
  //     firstTab: Number(route.params.firstTab),
  //     activityKey: route.query.activityKey,
  //   }),
  //   children: [
  //     {
  //       path: `1031_cp_love`,
  //       component: () =>
  //         import(
  //           /* webpackChunkName: '1031_cp_love' */ `@/views/2024/1031_cp_love/index.vue`
  //         ),
  //     },
  //   ],
  // },
  {
    path: "/activity-2024/annual-vote",
    component: () =>
      import(
        /* webpackChunkName: 'annual-vote' */ `@/views/2025/annual-vote/index.vue`
      ),
  },
  {
    path: "/activity-2024/annual-vote/records",
    component: () =>
      import(
        /* webpackChunkName: 'annual-vote' */ `@/views/2025/annual-vote/records.vue`
      ),
  },
  {
    path: "/activity-2024/call-up",
    component: () =>
      import(
        /* webpackChunkName: 'call-up' */ `@/views/2025/call-up/index.vue`
      ),
  },
  {
    path: "/activity-2024/up-market",
    component: () =>
      import(
        /* webpackChunkName: 'up-market' */ `@/views/2025/call-up/up-market.vue`
      ),
  },
  {
    path: "/activity-2024/up-data",
    component: () =>
      import(
        /* webpackChunkName: 'up-data' */ `@/views/2025/call-up/up-data.vue`
      ),
  },
  {
    path: "/activity-2024/up-rank",
    component: () =>
      import(
        /* webpackChunkName: 'up-rank' */ `@/views/2025/call-up/up-rank.vue`
      ),
  },
  {
    path: "/activity-2024/whale-change",
    component: () =>
      import(
        /* webpackChunkName: 'whale-change' */ `@/views/2025/whale-change/index.vue`
      ),
  },
  {
    path: "/activity-2024/whale-change/address",
    component: () =>
      import(
        /* webpackChunkName: 'whale-change' */ `@/views/2025/whale-change/address.vue`
      ),
  },
  {
    path: "/activity-2024/whale-change/address-list",
    component: () =>
      import(
        /* webpackChunkName: 'whale-change' */ `@/views/2025/whale-change/address-list.vue`
      ),
  },
  {
    path: "/activity-2024/whale-change/sign",
    component: () =>
      import(
        /* webpackChunkName: 'whale-change' */ `@/views/2025/whale-change/sign.vue`
      ),
  },
  {
    path: "/activity-2024/whale-change/progress",
    component: () =>
      import(
        /* webpackChunkName: 'whale-change' */ `@/views/2025/whale-change/progress.vue`
      ),
  },
  {
    path: "/activity-2024/whale-change/order",
    component: () =>
      import(
        /* webpackChunkName: 'whale-change' */ `@/views/2025/whale-change/order.vue`
      ),
  },
  {
    path: "/activity-2024/250116_yun/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250116_yun_first_index' */ `@/views/2024/250116_yun/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250116_yun/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250116_yun_module_index' */ `@/views/2024/250116_yun/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250116_yun",
  },
  {
    path: "/activity-2024/250123_she/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250123_she_first_index' */ `@/views/2024/250123_she/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },

  {
    path: "/activity-2024/250123_she/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250123_she_module_index' */ `@/views/2024/250123_she/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250123_she",
  },
  {
    path: "/activity-2024/250124_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250124_cp_love' */ `@/views/2024/250124_cp_love/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250124_cp_love",
  },
  {
    path: "/activity-2024/250206_ming/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250206_ming-first_index' */ `@/views/2024/250206_ming/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250206_ming/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250206_ming-module_index' */ `@/views/2024/250206_ming/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250206_ming",
  },
  {
    path: "/activity-2024/250213_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250213_cp_love-first_index' */ `@/views/2024/250213_cp_love/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250213_cp_love/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250213_cp_love-module_index' */ `@/views/2024/250213_cp_love/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250213_cp_love",
  },
  {
    path: "/activity-2024/250220_zhi/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250220_zhi-first_index' */ `@/views/2024/250220_zhi/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250220_zhi/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250220_zhi-module_index' */ `@/views/2024/250220_zhi/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250220_zhi",
  },
  {
    path: "/activity-2024/250227_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250227_relation' */ `@/views/2024/250227_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250227_relation",
  },
  {
    path: "/activity-2024/250306_xu/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250306_xu-first_index' */ `@/views/2024/250306_xu/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250306_xu/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250306_xu-module_index' */ `@/views/2024/250306_xu/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250306_xu",
  },
  {
    path: "/activity-2024/250313_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250313_cp_love-module_index' */ `@/views/2024/250313_cp_love/index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250313_cp_love",
  },
  {
    path: "/activity-2024/250320_zhua/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250320_zhua-first_index' */ `@/views/2024/250320_zhua/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250320_zhua/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250320_zhua-module_index' */ `@/views/2024/250320_zhua/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250320_zhua",
  },
  {
    path: "/activity-2024/250327_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250327_relation' */ `@/views/2024/250327_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250327_relation",
  },
  {
    path: "/activity-2024/250403_liu/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250403_liu-first_index' */ `@/views/2024/250403_liu/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250403_liu/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250403_liu-module_index' */ `@/views/2024/250403_liu/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250403_liu",
  },
  {
    path: "/activity-2024/250410_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250410_cp_love-module_index' */ `@/views/2024/250410_cp_love/index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250410_cp_love",
  },
  {
    path: "/activity-2024/250417_xin/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250417_xin-first_index' */ `@/views/2024/250417_xin/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250417_xin/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250417_xin-module_index' */ `@/views/2024/250417_xin/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250417_xin",
  },
  {
    path: "/activity-2024/250424_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250424_relation' */ `@/views/2024/250424_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250424_relation",
  },
  {
    path: "/activity-2024/250430_si/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250430_si-first_index' */ `@/views/2024/250430_si/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250430_si/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250430_si-module_index' */ `@/views/2024/250430_si/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250430_si",
  },
  {
    path: "/activity-2024/250510_cp_love/wishlist",
    component: () =>
      import(
        /* webpackChunkName: '250510_cp_love-wishlist' */ `@/views/2024/250510_cp_love/components/wishlist.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250510_cp_love/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250510_cp_love-first_index' */ `@/views/2024/250510_cp_love/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250510_cp_love/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250510_cp_love-module_index' */ `@/views/2024/250510_cp_love/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250510_cp_love",
  },
  {
    path: "/activity-2024/250515_feng/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250515_feng-first_index' */ `@/views/2024/250515_feng/first_index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
  },
  {
    path: "/activity-2024/250515_feng/:entryType/module/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250515_feng-module_index' */ `@/views/2024/250515_feng/components/module_index.vue`
      ),
    props: (route) => ({
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250515_feng",
  },
  {
    path: "/activity-2024/250522_relation/:entryType/:tab/:firstTab",
    component: () =>
      import(
        /* webpackChunkName: '250522_relation' */ `@/views/2024/250522_relation/index.vue`
      ),
    props: (route) => ({
      entryType: route.params.entryType,
      tab: Number(route.params.tab),
      firstTab: Number(route.params.firstTab),
    }),
    name: "250522_relation",
  },
];
